import { useState } from "react";
import {
  BTN_PRIMARY,
  BTN_SECONDARY,
  INPUT,
  LABEL,
} from "../../../../../styles";
import { Modal } from "../../../../../components/Modal";

export function ReportProblem({ reportOpen, setReportOpen, onReportarErro }) {
  const [erroDescricao, setErroDescricao] = useState("");
  const [enviando, setEnviando] = useState(false);
  return (
    <Modal titulo="Reportar problema" onClose={() => setReportOpen(false)}>
      <div style={{ marginBottom: 14 }}>
        <label style={LABEL}>Descricao</label>
        <textarea
          value={erroDescricao}
          onChange={(event) => setErroDescricao(event.target.value)}
          style={{ ...INPUT, minHeight: 120, resize: "vertical" }}
          placeholder="Descreva o problema encontrado no conteudo."
        />
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
        <button
          onClick={() => setReportOpen(false)}
          style={BTN_SECONDARY}
          disabled={enviando}
        >
          Cancelar
        </button>
        <button
          onClick={async () => {
            setEnviando(true);
            const sent = await onReportarErro(erroDescricao);
            setEnviando(false);
            if (sent) {
              setErroDescricao("");
              setReportOpen(false);
            }
          }}
          style={{ ...BTN_PRIMARY, opacity: enviando ? 0.6 : 1 }}
          disabled={enviando}
        >
          {enviando ? "Enviando..." : "Enviar"}
        </button>
      </div>
    </Modal>
  );
}
